function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.4,
  cx: 50,
  cy: 50,
  r: 50,
  fill: "#F8EAEB"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 32,
  fill: "#F8EAEB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9337 35.722H47.0117L48.2297 56.68H51.7577L52.9337 35.722ZM46.9277 62.728C46.9277 64.408 48.2717 65.794 49.9517 65.794C51.6737 65.794 53.0597 64.408 53.0597 62.728C53.0597 61.048 51.6737 59.62 49.9517 59.62C48.2717 59.62 46.9277 61.048 46.9277 62.728Z",
  fill: "#EB6469"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.4668 40.6232H48.5082L49.1167 51.0936H50.8793L51.4668 40.6232ZM48.4662 54.1151C48.4662 54.9544 49.1377 55.6469 49.977 55.6469C50.8373 55.6469 51.5297 54.9544 51.5297 54.1151C51.5297 53.2758 50.8373 52.5624 49.977 52.5624C49.1377 52.5624 48.4662 53.2758 48.4662 54.1151Z",
  fill: "#EB6469"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0feec522.svg";
export { ForwardRef as ReactComponent };